import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Form, Field } from "react-final-form";
import { useAlert } from "react-alert";

import context from "../../../context/auth-context";
import errorHandler from "../../../hoc/ErrorHandler";
import { RANDOM_STRING } from "../../../constants";
import Modal from "../Modal/CenterModal/CenterModalNew";

const SetTimeZone = () => {
  const [timeZones, setTimeZones] = useState(null);

  const authContext = useContext(context);
  const alert = useAlert();

  useEffect(() => {
    axios.get(`/timezones/${authContext.companyCode}`).then((response) => {
      if (response) setTimeZones(response.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setTimezoneHandler = async (info) => {
    const response = await axios.post(
      `/companies/${authContext.companyId}/timezone`,
      info,
      {
        headers: {
          Authorization: authContext.accessToken,
          "Company-Code": authContext.companyCode,
        },
      }
    );

    if (response && response.data)
      alert.show("Timezone set", { type: "success" });
  };

  return (
    <Modal
      modalId="timezoneModal"
      modalTitle={`Set ${authContext.companyName} time zone`}
    >
      <div className="alert alert-info text-left">
        <i className="icon fa-info-circle" aria-hidden="true"></i>&nbsp;Company
        time zone needs to be set before proceeding
      </div>
      <Form
        onSubmit={setTimezoneHandler}
        render={({ handleSubmit, submitting, pristine, values }) => (
          <form onSubmit={handleSubmit}>
            <div className="form-group form-material">
              <label className="form-control-label" htmlFor="timezone">
                Company Time zone<sup>*</sup>
              </label>
              <Field
                className="form-control empty"
                id="timezone"
                name="timezone"
                component="select"
              >
                <option></option>
                {timeZones &&
                  timeZones.map((zone) => (
                    <option key={RANDOM_STRING(6)} value={zone.id}>
                      {zone.name}
                    </option>
                  ))}
              </Field>
            </div>
            <div className="text-center" style={{ marginTop: "10px" }}>
              <button
                type="submit"
                className="btn btn-default btn-sm btn-raised btn-animate btn-animate-side waves-effect waves-classic"
                disabled={submitting || pristine}
              >
                <span>
                  <i className="icon ti-check" aria-hidden="true"></i>Set time
                  zone
                </span>
              </button>
            </div>
            {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
          </form>
        )}
      />
    </Modal>
  );
};

export default errorHandler(SetTimeZone, axios);
